function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Icon from '../icon';

var Message =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Message, _PureComponent);

  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Message).call(this, props));

    _this.onClick = function (e) {
      var _this$props = _this.props,
          hasArrow = _this$props.hasArrow,
          onClick = _this$props.onClick;

      if (hasArrow && typeof onClick === 'function') {
        onClick(e);
      }
    };

    _this.onClose = function () {
      _this.setState({
        visible: false
      });
    };

    _this.state = {
      visible: true
    };
    return _this;
  }

  _createClass(Message, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          theme = _this$props2.theme,
          size = _this$props2.size,
          icon = _this$props2.icon,
          hasArrow = _this$props2.hasArrow,
          closable = _this$props2.closable,
          children = _this$props2.children;
      var visible = this.state.visible;
      var classes = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(theme), !!theme), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(size), !!size), _classnames));
      var iconRender = icon && React.createElement("div", {
        className: "".concat(prefixCls, "__icon")
      }, icon);
      var renderCloseIcon = closable && React.createElement(Icon, {
        type: "wrong",
        onClick: this.onClose
      });
      var renderArrow = hasArrow && React.createElement(Icon, {
        type: "arrow-right"
      });
      var noFooter = !closable && !hasArrow;
      return visible && React.createElement("div", {
        className: classes,
        onClick: this.onClick
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__header")
      }, iconRender), React.createElement("div", {
        className: "".concat(prefixCls, "__body")
      }, children), !noFooter && React.createElement("div", {
        className: "".concat(prefixCls, "__footer")
      }, renderArrow, renderCloseIcon));
    }
  }]);

  return Message;
}(PureComponent);

Message.defaultProps = {
  prefixCls: 'za-message',
  theme: 'primary',
  hasArrow: false,
  closable: false
};
export { Message as default };